import translate from './language.language';

class HealthcarebookLanguageController {
    $onInit() {
        this.translate = translate;
        this.selectedLanguage = localStorage.getItem('languaje') || "en";
    }
}

export default HealthcarebookLanguageController;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/language/language.controller.js
// module id = 629
// module chunks = 0